export default "__VITE_ASSET__DCmyr2U$__"